module.exports = __webpack_public_path__ + "img/2.56bd5fc5.png";